export default __webpack_public_path__ + "static/media/jisoo.b77a7780.jpg";